import "./style.scss";


import { format } from "date-fns";
import { formatNumber, formatUSD } from "helpers/helpers";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Label } from 'recharts';
import { useMemo, useState } from "react";


const StatisticsChart = ({chart, xDataKey, yDataKey, xLabelVisible = true}) => {

  const [formattedChart, setFormattedChart] = useState(chart);

  // function CustomToolTip({ active, payload, label }) {
  //   if(!active) return "";
  //   const assetPrice = payload && active
  //   ? formatUSD(payload[0].payload[yDataKey])
  //   : "";
  
  //   return <div className="tooltip">
  //       <p>Daily Volume: {assetPrice}</p>
  //       <p>Date: {format(new Date(payload[0].payload.time), "MMM d yyyy")}</p>
        
  //   </div>;
  // }

  if(!chart)
  return <div className="chartPreloader"></div>

  return <ResponsiveContainer width="100%" height="100%">
    <AreaChart
      width={"100%"}
      height={300}
      data={chart}
      margin={{
        top: 5,
        right: 0,
        left: -60,
        bottom: xLabelVisible? 5 : -25,
      }}
    >
      <CartesianGrid opacity={0.2} vertical={false} />
      <XAxis
        dataKey="date"
        axisLine={false}
        tickLine={false}
        padding={{left:30, right:30}}
        tickFormatter={(date) => {
          const d = new Date(date);
          return xLabelVisible? (d.toLocaleDateString("en-US")) : "";
        }}
      />
      <YAxis
        orientation={"left"}
        type="number"
        dataKey="price"
        domain={["auto", "auto"]}
        axisLine={false}
        tickLine={false}
        opacity={1}
        tickCount={5}
        tick={true}
        fontSize={"1.2rem"}
        fontWeight={800}
        tickFormatter={(number) => {
        // return ("$"+formatNumber(number,0) + "M");
        return ""
        }}
      >
        {!xLabelVisible && <Label value="Historical Trading Volume" offset={60} dy={7} dx={10} position="insideBottomLeft" fill="#C3C2D4" />}
      </YAxis>
      {/* <Tooltip content={<CustomToolTip />} /> */}
      <Area type="monotone" dataKey="price" strokeWidth={2} stroke="var(--green)" fill="transparent" />
    </AreaChart>
    
  </ResponsiveContainer>

}

export default StatisticsChart;

function formatDate(date) {
  return format(new Date(date), "MMM d");
}